import * as React from 'react';
import classnames from 'classnames';
import styles from '../styles/grid.css';
/**
 * **Row** is a horizontal section inside a grid
 *
 * Allows adding arbitrary props that are allowed on `div` elements
 * (e.g. `id`, `style` or `title`)
 */
export const Row = ({ className, innerRef, ...other }) => {
    const classes = classnames(styles.row, className);
    return React.createElement("div", { className: classes, ref: innerRef, ...other });
};
Row.displayName = 'Row';
//# sourceMappingURL=row.js.map